import { replacePlaceholders } from '@/core/utils/installation'

import type { BuildImportCodeParams } from '../interfaces'

import { collectCrossGraftImports } from './collectCrossGraftImports'
import { computeGcgNames, toGcgPlaceholders } from './computeGcgNames'

export const buildImportCode = ({
  selectedTechnology,
  technologyImports,
  technologyLibraryImports,
  libraryData,
  classData,
  packageManager,
}: BuildImportCodeParams): string => {
  if (!selectedTechnology) return ''

  const template = classData
    ? (technologyImports[selectedTechnology] ?? '')
    : (technologyLibraryImports[selectedTechnology] ?? '')
  if (!template) return ''

  const names = computeGcgNames({ selectedTechnology, libraryData })

  const primaryImport = replacePlaceholders(template, {
    ...toGcgPlaceholders(names),
    packageManager,
    library: libraryData?.name ?? 'unknown-library',
    class: classData?.name ?? 'unknown-class',
  })

  const crossGraftImports = collectCrossGraftImports({
    selectedTechnology,
    libraryData,
    classData,
    packageManager,
  })

  if (crossGraftImports.length === 0) {
    return primaryImport
  }

  const collapsedPrimary = !classData && crossGraftImports.includes(primaryImport) ? [] : [primaryImport]

  return [...crossGraftImports, ...collapsedPrimary].join('\n')
}
